import React from 'react';

const SettingLeftSideBar = ({item, setItem}) => {

    const arrBar = [
        'Security',
        'Payment',
        'Access',
        'Language and Time',
        'Notification'
    ]
    return (
        <div className='setting_component_left_side_bar_wrap'>
            {arrBar.map((nav,idx) => (
                <div key={idx} className={`setting_component_left_side_bar_item ${nav === item ? 'setting_component_left_side_bar_item_active' : ''}`} onClick={()=>setItem(nav)}>
                    <img src={`${nav !== item ? `/img/nav/${nav}.svg` : `/img/nav/${nav}Black.svg`}`} alt="" />
                    <p>{nav}</p>
                </div>
            ) )}
            {/* <p>Security</p>
            <p>Payment</p>
            <p>Access</p>
            <p>Language and Time</p>
            <p>Notification</p> */}
        </div>
    );
};

export default SettingLeftSideBar;